export default "__VITE_ASSET__BMyv9KgP__"